<div class="contentItemMain">
    <a [routerLink]="['/' + languageCode, 'content', id]">
        <img src="{{imageLocation}}Arrows_12x16_CCC.png" alt="{{title}}"/>
    </a>
    <div class="contentItem">
        <a [routerLink]="['/' + languageCode, 'content', id]" class="contentLink">{{title}}</a>
        <p *ngIf="description !== ''">&nbsp;-&nbsp;{{description}}</p>
    </div>
</div>
